import { render, staticRenderFns } from "./DeTabs.vue?vue&type=template&id=39e1dfa4&scoped=true"
import script from "./DeTabs.vue?vue&type=script&lang=js"
export * from "./DeTabs.vue?vue&type=script&lang=js"
import style0 from "./DeTabs.vue?vue&type=style&index=0&id=39e1dfa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1dfa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e1dfa4')) {
      api.createRecord('39e1dfa4', component.options)
    } else {
      api.reload('39e1dfa4', component.options)
    }
    module.hot.accept("./DeTabs.vue?vue&type=template&id=39e1dfa4&scoped=true", function () {
      api.rerender('39e1dfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/DeTabs.vue"
export default component.exports